export default __webpack_public_path__ + "static/media/Report.a1f75894.png";